import axios from 'axios';

export const gameAPI = axios.create({
  baseURL: 'https://api.rawg.io/api',
});

export const tmdbAPI = axios.create({
  baseURL: 'https://api.themoviedb.org/3',
});

// Backend API instance with auth token handling
export const backendAPI = axios.create({
  baseURL: process.env.REACT_APP_API_URI,
  headers: {
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Enable sending cookies with requests
});

// Request interceptor - now cookies are used for auth
// Fallback to localStorage for backwards compatibility during transition
backendAPI.interceptors.request.use(
  (config) => {
    // Cookies are now the primary auth mechanism (httpOnly, more secure)
    // This fallback is for backwards compatibility and will be removed later
    const token = localStorage.getItem('loginToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

// Response interceptor to handle token expiration
backendAPI.interceptors.response.use(
  (response) => response,
  (error) => {
    const statusCode = error.response?.status;

    if (statusCode === 401) {
      // Check if token expired
      const errorData = error.response?.data;

      if (errorData?.expired || errorData?.message?.includes('expired')) {
        // Clear any localStorage token (for backwards compatibility)
        localStorage.removeItem('loginToken');

        // Cookie will be cleared by backend or expired automatically
        // Redirect to login page
        const currentPath = `${window.location.pathname}${window.location.search}${window.location.hash}`;
        window.location.href = `/login?from=${encodeURIComponent(currentPath)}`;

        // Show notification (optional - you can add a toast library)
        alert('Your session has expired. Please login again.');
      }
    }

    return Promise.reject(error);
  },
);

const errorHandler = (error) => {
  const statusCode = error.response?.status;

  if (error.code === 'ERR_CANCELLED') {
    console.log(error);

    return Promise.resolve();
  }

  // logging only errors that are not 401
  if (statusCode && statusCode !== 401) {
    console.error(error);
  }

  return Promise.reject(error);
};

// registering the custom error handler to the
// "api" axios instance
gameAPI.interceptors.response.use(undefined, (error) => errorHandler(error));
